import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

export const gradientButtonShift = keyframes`
  0% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
`;

export const Wrapper = styled.section`
  position: relative;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  @media (max-width: 430px) {
    min-height: 568px;
  }
  h1,
  p,
  button {
    will-change: transform, opacity;
    backface-visibility: hidden;
    transform: translateZ(0);
  }
`;

export const BackgroundVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* make sure the video covers the background */
  z-index: 1; /* put it behind the content */
`;
export const ContentWrapper = styled.div`
  position: absolute;
  bottom: 0;
  z-index: 3;
  max-width: var(--container);
  width: 100%;
  padding: 0;
  @media (max-width: 1320px) {
    padding: 0 var(--section_padding);
  }
`;
export const Layer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  z-index: 2;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.6) 100%
  );
`;

export const Content = styled.div`
  width: 100%;
  padding: 100px 0 70px;
  position: relative;
  h1,
  p {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;

    /* Hardware acceleration */
    transform: translateZ(0);
    will-change: transform, opacity;
  }
  h1 {
    max-width: 760px;
    color: var(--clear-white);
    font-size: var(--font-size-40px);
    font-style: normal;
    font-weight: 800;
    line-height: 52px;
    text-transform: uppercase;
    white-space: pre-wrap;
    will-change: opacity, transform;
    span {
      color: var(--brand-color);
    }
  }
  p {
    color: var(--clear-white);
    font-size: var(--font-size-20px);
    font-style: normal;
    font-weight: 500;
    line-height: 28px; /* 28px */
    margin: 8px 0 32px;
    will-change: opacity, transform;
  }
  @media (max-width: 1440px) {
    padding: 100px 0 50px;
  }
  @media (max-width: 1024px) {
    padding: 60px 0 40px;
    h1 {
      max-width: 100%;
      font-size: var(--font-size-32px);
      font-style: normal;
      font-weight: 800;
      line-height: 120%; /* 33.6px */
      letter-spacing: -0.64px;
      text-transform: uppercase;
    }
    p {
      font-size: var(--font-size-16px);
      font-style: normal;
      font-weight: 400;
      line-height: 120%;
    }
  }
  @media (max-width: 768px) {
    padding: 60px 0 40px;
    h1 {
      max-width: 100%;
      font-size: var(--font-size-28px);
      font-style: normal;
      font-weight: 800;
      line-height: 120%; /* 33.6px */
      letter-spacing: -0.56px;
      text-transform: uppercase;
    }
    p {
      font-size: var(--font-size-16px);
      font-style: normal;
      font-weight: 400;
      line-height: 120%;
    }
  }
`;

export const MyButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: var(--radius-full);
  padding: 12px 20px;
  background: linear-gradient(
    91deg,
    #fbce18 0.28%,
    #ff942f 27.52%,
    #e66129 65.37%,
    #f9963f 99.72%
  );

  cursor: pointer;
  outline: none;
  border: none;
  color: var(--clear-white);
  text-align: center;
  font-size: var(--font-size-18px);
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  background-size: 200% 200%;
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease;

  .icon {
    display: inline-flex;
    flex: 0 0 auto;
  }

  &:hover {
    box-shadow: 0 8px 20px rgba(255, 148, 47, 0.4);
    animation: ${gradientButtonShift} 3s ease infinite;
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 4px 10px rgba(255, 148, 47, 0.2);
  }

  @media (max-width: 1024px) {
    font-size: var(--font-size-16px);
    font-style: normal;
    font-weight: 500;
    line-height: var(--font-line_height_24); /* 150% */
  }
`;
